import { render, staticRenderFns } from "./SelecaoNivelTpl.vue?vue&type=template&id=05f4fd5c&"
import script from "./SelecaoNivelTpl.vue?vue&type=script&lang=js&"
export * from "./SelecaoNivelTpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/taylor-minhasvendas-frontend-teste/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05f4fd5c')) {
      api.createRecord('05f4fd5c', component.options)
    } else {
      api.reload('05f4fd5c', component.options)
    }
    module.hot.accept("./SelecaoNivelTpl.vue?vue&type=template&id=05f4fd5c&", function () {
      api.rerender('05f4fd5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/lista-vez/SelecaoNivelTpl.vue"
export default component.exports